import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { BaseAsideDataInterface } from '../../_interfaces/base-aside-data.interface';
import { BaseButtonSize } from '../../../../shared/components/button/base-button.component';
import { BaseLanguageSwitchColors } from '../../../../shared/enums/base-language-switch-colors.enum';
import { BASE_ASIDE_MODEL } from '../../_models/base-aside.model';
import { BaseExternalUrls } from '../../../../shared/enums/base-external-urls.enum';
import { BaseAppRoutesEnum } from '../../../../shared/enums/base-app-routes.enum';

@Component({
  selector: 'base-auth-wrapper',
  templateUrl: './base-auth-wrapper.component.html',
})
export class BaseAuthWrapperComponent implements OnInit, OnDestroy {
  @Input() logo = 'assets-global/images/stazzle-logo-white.svg';
  asideData: BaseAsideDataInterface;
  buttonSize = BaseButtonSize;
  colors = BaseLanguageSwitchColors;
  isRegisterPage: boolean;
  baseStazzleLinks = BaseExternalUrls;

  private destroy$ = new Subject();

  constructor(private router: Router) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        const navEndEvent = event as NavigationEnd;
        this.asideData = this.checkAuthUrl(navEndEvent.urlAfterRedirects);
      });
  }

  ngOnInit() {
    this.checkAuthPage(this.router.url);

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        this.checkAuthPage((event as NavigationEnd).url);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  goTo(link: string): void {
    window.open(link, '_blank');
  }

  checkAuthPage(url: string): void {
    this.isRegisterPage = url.indexOf(BaseAppRoutesEnum.REGISTER) > -1;
  }

  checkAuthUrl(url: string): BaseAsideDataInterface {
    if (url.startsWith(BaseAppRoutesEnum.REGISTER) || url.startsWith(BaseAppRoutesEnum.INVITE)) {
      return BASE_ASIDE_MODEL.registration;
    } else if (url.startsWith(BaseAppRoutesEnum.EMASTERS)) {
      return BASE_ASIDE_MODEL.emasters;
    } else {
      return BASE_ASIDE_MODEL.login;
    }
  }
}
